import { createApp } from 'vue'
import TokyoCatchInputPacking from './tokyo-catch-input-packing.vue'
import i18nPlugin, { i18n, loadTranslations } from "./i18n"
import { createPinia } from "pinia"

$.onmount('[data-vue=tokyo-catch-input-packing]', async function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)
  const pinia = createPinia()
  const app = createApp(TokyoCatchInputPacking, { initialData })
  app.use(pinia)
  app.use(i18nPlugin)
  await loadTranslations(i18n)
  $('body').tooltip({
    selector: '[data-toggle="tooltip"]',
    container: 'body'
  })
  app.mount(this)
})
